// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"js/manifest": 0,
	"css/templates/home": 0,
	"css/templates/front-page": 0,
	"css/templates/archive-seo-cases": 0,
	"css/templates/404": 0,
	"css/app": 0,
	"css/wp-dashboard/login": 0,
	"css/wp-dashboard/editor": 0,
	"css/wp-dashboard/colors": 0,
	"css/wp-dashboard/admin": 0,
	"css/blocks/сases": 0,
	"css/blocks/teams": 0,
	"css/blocks/tabs": 0,
	"css/blocks/seo-hidden": 0,
	"css/blocks/review-archive": 0,
	"css/blocks/review": 0,
	"css/blocks/reasons": 0,
	"css/blocks/post-content": 0,
	"css/blocks/points-with-list": 0,
	"css/blocks/points": 0,
	"css/blocks/partners": 0,
	"css/blocks/mission": 0,
	"css/blocks/list-with-title": 0,
	"css/blocks/list": 0,
	"css/blocks/image": 0,
	"css/blocks/icons-with-label": 0,
	"css/blocks/hero-second": 0,
	"css/blocks/hero": 0,
	"css/blocks/form-small": 0,
	"css/blocks/form": 0,
	"css/blocks/faq": 0,
	"css/blocks/decision": 0,
	"css/blocks/cta-popup-description": 0,
	"css/blocks/cta-popup": 0,
	"css/blocks/cta-link-bg": 0,
	"css/blocks/cta-link": 0,
	"css/blocks/cta-form": 0,
	"css/blocks/countries": 0,
	"css/blocks/contact-form": 0,
	"css/blocks/clasic-editor": 0,
	"css/blocks/cases-slider": 0,
	"css/blocks/cards-small": 0,
	"css/blocks/cards-big": 0,
	"css/blocks/articles-slider": 0,
	"css/blocks/articles-grid": 0,
	"css/blocks/advantages": 0,
	"css/templates/single-team": 0,
	"css/templates/single-seo-cases": 0,
	"css/templates/single": 0,
	"css/templates/index": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkskeleton_theme"] = self["webpackChunkskeleton_theme"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));